'use client';

import { useState } from 'react';

import { Accordion } from '@mantine/core';

import { Title } from '@/styles/global.elements';
import { Container, Wrap, ContactMessage } from './faq.elements';
import { Button } from '@/elements/button/button.component';
import { RichText } from '@/elements/rich-text/rich-text.component';

const FAQ = ({ faq: allQuestions }) => {
  // Filter out any undefined or invalid FAQ items
  const validQuestions = allQuestions?.filter((q) => q && q.question && q.answer) || [];
  const [questions, setQuestions] = useState(validQuestions.slice(0, 4));

  const loadMore = () => {
    setQuestions(validQuestions);
  };

  return (
    <Container>
      <Title $medium $align="left">
        Najčešće postavljana pitanja
      </Title>
      <Wrap>
        <Accordion id="faq-accordion" chevronPosition="right" variant="separated" radius="md">
          {questions.map(({ question, answer }) => (
            <Accordion.Item key={question} value={question}>
              <Accordion.Control>{question}</Accordion.Control>
              <Accordion.Panel style={{ lineHeight: 1.2, fontWeight: 300 }}>
                <RichText content={answer} />
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
        {questions.length < validQuestions.length ? (
          <Button onClick={loadMore} alignSelf="center" naked>
            Prikaži više
          </Button>
        ) : null}
        <ContactMessage>
          Ako imaš dodatnih pitanja, javi nam se na&nbsp;
          <a href="mailto:ured@izvrsnost.hr">ured@izvrsnost.hr</a>
        </ContactMessage>
      </Wrap>
    </Container>
  );
};

export { FAQ };
